import { Text, type TextProps } from "@chakra-ui/react";
import type { FC } from "react";

export const RequiredIndicator: FC<TextProps> = (props) => {
  return (
    <Text as="span" color="semantic.core.negative" {...props}>
      *
    </Text>
  );
};
